import { render, staticRenderFns } from "./AutoPauseResume.vue?vue&type=template&id=7d80c6b4&scoped=true"
import script from "./AutoPauseResume.vue?vue&type=script&lang=ts"
export * from "./AutoPauseResume.vue?vue&type=script&lang=ts"
import style0 from "./AutoPauseResume.vue?vue&type=style&index=0&id=7d80c6b4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d80c6b4",
  null
  
)

export default component.exports